import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiDropdown, SuiDropdownOption, SuiTextInput } from '@splashthat/sui';

import './IncludeOtherStyles.styl';

const OTHER_LABEL = 'Other';
const baseClassName = 'DropdownIncludeOther';

class DropdownIncludeOther extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        onChange: () => {},
    };

    state = {
        selected: null,
        otherActive: false,
        otherValue: '',
    };

    handleChangeInput = (event, otherValue) => {
        this.setState((state) => ({
            ...state,
            otherValue,
        }));

        if (this.props.onChange) {
            this.props.onChange(event, otherValue);
        }
    };

    handleChangeGroup = (event, selected) => {
        this.setState((state) => ({
            ...state,
            selected,
            otherActive: selected === (this.state.otherValue || 'other'),
        }));

        if (this.props.onChange) {
            this.props.onChange(event, selected);
        }
    };

    render() {
        return (
            <div>
                <SuiDropdown {...this.props} onChange={this.handleChangeGroup}>
                    {this.props.children}
                    <SuiDropdownOption
                        key="other"
                        value={this.state.otherValue.trim() || 'other'}
                        displayValue={OTHER_LABEL}
                        onChange={this.handleChangeOther}
                    />
                </SuiDropdown>

                {this.state.otherActive && (
                    <SuiTextInput
                        fullWidth
                        className={`${baseClassName}__other-input`}
                        value={this.state.otherValue}
                        onChange={this.handleChangeInput}
                        title={OTHER_LABEL}
                    />
                )}
            </div>
        );
    }
}

export default DropdownIncludeOther;
